import { userConstants } from '../_constants';

export function forgotPassword(state = {}, action) {
  switch (action.type) {
    case userConstants.FORGOT_REQUEST:
      return {};
    case userConstants.FORGOT_SUCCESS:
      return {};
    case userConstants.FORGOT_FAILURE:
      return {};
    default:
      return state
  }
}